import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors, ScreenDepth } from "@ryde/theme";

/**
 * Full-screen host for the investigation workspace. `inset: 0` is load-bearing: the workspace no longer
 * measures itself against the viewport, so any inset here would push its docked transport bar off-screen.
 */
export const InvestigationOverlayStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-investigation-overlay",
})`
  position: fixed;
  inset: 0;
  z-index: ${ScreenDepth.RIDE_INVESTIGATION_OVERLAY};
  display: flex;
  background: ${rydeColors.white};
`;
